<template>
  <div class="header">
    <router-link class="link"
                 v-if="privileges&&privileges.LabelingBasic"
                 :to="{ name: 'label', query: $route.query}"><i class="el-icon-edit"></i>
      标注</router-link>
    <router-link class="link"
                 v-if="privileges&&privileges.LabelingAdvanced"
                 :to="{ name: 'review', query: $route.query}"><i class="el-icon-check"></i>
      审核</router-link>
    <router-link class="link"
                 v-if="privileges&&privileges.LabelingAdvanced"
                 :to="{ name: 'history', query: $route.query}"><i class="el-icon-tickets"></i>
      历史</router-link>
    <router-link class="link"
                 v-if="privileges&&privileges.LabelingAdvanced"
                 :to="{ name: 'concat', query: $route.query}"><i class="el-icon-document"></i>
      拼接</router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['privileges']),
  },
}
</script>

<style lang="scss" scoped>
.header {
  text-align: left;
  padding: 10px;
  padding-bottom: 0;
  .link {
    margin: 10px;
    user-select: none;
  }
  .router-link-active {
    color: #409eff;
  }
}
</style>
